export default [
	{
		title: 'menu.contact.contact',
		icon: ['fal', 'phone'],
		to: { name: 'contactUs' },
		accessRights: 'MVP',
		mobile: true,
		desktop: true,
		home: true,
	},
]
